import {
  ValidatorInterface,
  ViolationFields,
} from '@/validators/validatorTypes';

export class PersonalEmailDataValidator implements ValidatorInterface {
  validate(target: string): ViolationFields[] {
    const violations = [];
    //pattern identifies email addresses according to RFC 5322
    const pattern =
      // eslint-disable-next-line no-control-regex
      /^[a-zA-Z0-9äöüÄÖÜß.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9äöüÄÖÜß](?:[a-zA-Z0-9äöüÄÖÜß-]{0,61}[a-zA-Z0-9äöüÄÖÜß])?(?:\.[a-zA-Z0-9äöüÄÖÜß](?:[a-zA-Z0-9äöüÄÖÜß-]{0,61}[a-zA-Z0-9äöüÄÖÜß])?)+$/;
    const matches = pattern.exec(target.toLowerCase());
    // if matches are not found: E-Mail violates RFC 5322
    if (matches === null) {
      violations.push(ViolationFields.EMAIL);
    }

    return violations;
  }
}
